import React, { useEffect } from "react";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";

const AuthChecker = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      if (!auth.currentUser) {
        navigate("/");
      }
    }, 1000);
  }, []);

  return <>{children}</>;
};

export default AuthChecker;
